import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M2.665 14.032c-.366 0-.68-.13-.941-.392a1.284 1.284 0 0 1-.392-.941v-8c0-.367.13-.681.392-.942.26-.261.575-.392.941-.392h8c.367 0 .68.13.942.392.261.261.392.575.392.942v3l2.666-2.667v7.333L12 9.7v3c0 .366-.13.68-.392.941a1.284 1.284 0 0 1-.942.392zm0-1.333h8v-8h-8z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }